import { render, staticRenderFns } from "./PageCropRotation.vue?vue&type=template&id=8563e6f2&scoped=true&"
import script from "./PageCropRotation.vue?vue&type=script&lang=js&"
export * from "./PageCropRotation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8563e6f2",
  null
  
)

export default component.exports